import React, { forwardRef, useImperativeHandle } from "react";
import { useAutoScrollToContent } from "../../../hooks/useAutoScrollToContent";

interface AutoScrollWrapperProps {
	scrollContainer: React.RefObject<HTMLElement> | HTMLElement | null;
	enabled?: boolean;
	offset?: number;
	behavior?: ScrollBehavior;
	delay?: number;
	children: React.ReactNode;
	ref?: React.Ref<AutoScrollWrapperRef>;
}

export interface AutoScrollWrapperRef {
	scrollToElement: (element: HTMLElement | null) => void;
	scrollToRevealedContent: (toggleElement: HTMLElement | null, contentElement?: HTMLElement | null) => void;
	isContentVisible: (element: HTMLElement | null) => boolean;
}

const AutoScrollWrapper = forwardRef<AutoScrollWrapperRef, AutoScrollWrapperProps>(
	({ scrollContainer, enabled = true, offset = 20, behavior = "smooth", delay = 100, children }, ref) => {
		const { scrollToElement, scrollToRevealedContent, isContentVisible } = useAutoScrollToContent({
			scrollContainer,
			enabled,
			offset,
			behavior,
			delay,
		});

		useImperativeHandle(ref, () => ({
			scrollToElement,
			scrollToRevealedContent,
			isContentVisible,
		}));

		return <>{children}</>;
	},
);

export default AutoScrollWrapper;
